export const CHOOSE_ACCOUNT_TYPE_HEADER = "choose-account-type-header";
export const CHOOSE_ACCOUNT_TYPE_SUB_HEADER = "choose-account-type-sub-header";
export const LOG_IN_LINK = "choose-account-type-log-in-link";
export const FPACT_CARD_HEADER = "choose-account-type-fpact-card-header";
export const FPACT_CARD_SUB_HEADER =
  "choose-account-type-fpact-card-sub-header";
export const START_NEW_APPLICATION_BUTTON =
  "choose-account-type-start-new-application-button";
export const HAP_CARD_HEADER = "choose-account-type-hap-card-header";
export const HAP_CARD_SUB_HEADER = "choose-account-type-hap-card-sub-header";
export const LINK_MY_APPLICATION_BUTTON =
  "choose-account-type-link-my-application-button";
export const CLIPBOARD_ICON_ID = "clipboard-icon";
export const HAP_ICON_ID = "hap-icon";
